import React, { useRef } from 'react';
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion';
import { ArrowDownRightIcon } from 'lucide-react';
import { images } from '../data/images';
const words = ['Pure.', 'Clear.', 'Proven.'];
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  const ref = useRef<HTMLElement>(null);
  const reduce = useReducedMotion();
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start start', 'end start']
  });
  const imgY = useTransform(scrollYProgress, [0, 1], ['0%', reduce ? '0%' : '18%']);
  const imgScale = useTransform(scrollYProgress, [0, 1], [1, reduce ? 1 : 1.08]);
  return <section ref={ref} id="top" className="relative mx-auto max-w-7xl px-6 pb-16 pt-28 lg:px-10 lg:pb-24 lg:pt-32" data-id="element-44" data-mp="s9ghy2ytqm9r">
      <div className="grid items-end gap-10 lg:grid-cols-12" data-id="element-45" data-mp="nekmesudpgrw">
        <div className="relative z-10 lg:col-span-7" data-id="element-46" data-mp="3d2bj5ngruvuh">
          <h1 className="font-display text-[clamp(4.5rem,11vw,10rem)] font-medium leading-[0.85] tracking-tight text-ink" data-id="element-47" data-mp="382p6pg8rpjmq">
            {words.map((w, i) => <span key={w} className="block overflow-hidden pb-2" data-id="element-48" data-mp="3j9agpbwlmo4m" data-mpi={i}>
                <motion.span className={`block ${i === 1 ? 'pl-[0.6em] italic text-clay' : ''} ${i === 2 ? 'pl-[0.2em]' : ''}`} initial={reduce ? false : {
              y: '100%'
            }} animate={{
              y: 0
            }} transition={{
              duration: 0.3,
              delay: 0.08 + i * 0.06,
              ease
            }} data-id="element-49" data-mp="3o6khtotcoo8a">
                  {w}
                </motion.span>
              </span>)}
          </h1>
          <motion.div initial={reduce ? false : {
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.32,
          ease
        }} className="mt-10 flex flex-col gap-8 sm:flex-row sm:items-end sm:justify-between lg:pr-10" data-id="element-50" data-mp="35aue9x5rrjsa">
            <p className="max-w-sm text-lg leading-relaxed text-muted" data-id="element-51" data-mp="2hlj8205ngx6r">
              Pure Marokkaanse schoonheid, zoals ze al generaties gebruikt wordt. Wat het is, wat het doet en hoe je het gebruikt.
            </p>
            <a href="#ritueel" className="group inline-flex w-fit items-center gap-3 whitespace-nowrap rounded-full bg-clay py-2 pl-6 pr-2 text-sm font-medium text-sand transition-colors duration-150 hover:bg-clay-dark" data-id="element-52" data-mp="nbl4gqm0mqd3">
              Ontdek het ritueel
              <span className="grid h-9 w-9 place-items-center rounded-full bg-sand text-clay transition-transform duration-200 group-hover:rotate-[-45deg]" data-id="element-53" data-mp="1b0vubd1tv0cg">
                <ArrowDownRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-54" data-mp="162c95ev25sl5" />
              </span>
            </a>
          </motion.div>
        </div>

        <motion.div initial={reduce ? false : {
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease
      }} className="relative lg:col-span-5" data-id="element-55" data-mp="x1edbjurwrdn">
          <div className="overflow-hidden rounded-[2.5rem] bg-linen" data-id="element-56" data-mp="3hpse948bhp1i">
            <motion.img src={images.hero} alt="Vrouw met natuurlijke, verzorgde huid in warm daglicht" style={{
            y: imgY,
            scale: imgScale
          }} className="aspect-[4/5] w-full object-cover" data-id="element-57" data-mp="1xa43fdhjeij3" />
          </div>
          <div className="absolute -left-6 bottom-8 hidden rounded-2xl bg-sand/90 px-5 py-4 shadow-[0_12px_32px_-16px_rgba(42,31,24,0.4)] backdrop-blur sm:block" data-id="element-58" data-mp="2b0po97qjx2jm">
            <p className="font-display text-3xl leading-none text-ink" data-id="element-59" data-mp="2fzj2519r2vkb">16</p>
            <p className="mt-1 text-xs text-muted" data-id="element-60" data-mp="2kxu8v34r0pyb">pure producten, 9 stappen</p>
          </div>
        </motion.div>
      </div>
    </section>;
}